// 立项项目阶段变更
import request from '@/utils/request'

const BaseUrl = '/projectMilestonePlanChange'

// //findList 查询列表
export function getMilestonePlanChangePage(params) {
  return request({
    url: `${BaseUrl}`,
    method: 'get',
    params
  })
}
// 添加
export function addMilestonePlanChange(data) {
  return request({
    url: `${BaseUrl}`,
    method: 'post',
    data
  })
}

// 更新
export function updateMilestonePlanChange(data) {
  return request({
    url: `${BaseUrl}/status`,
    method: 'post',
    data
  })
}

